module.exports = __webpack_public_path__ + "media/src/img/favicon-4f88fa5ccf236d2ae719c99aa5d8837b.ico";